/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
query FallbackRoutePlanReadQuery($routePlanId: ID) {
  FallbackRoutePlanRead(routePlanId: $routePlanId) {
    id,
    createdAt,
    updatedAt,
    priority,
    fallbackTimeout,
    status,
    Mcc {
      mcc,
      countryName
    },
    Mnc {
      id,
      mnc,
      network
    },
    FallbackRoute {
      displayName
    }
    VendorAccount {
      id,
      displayName
    }
  }
}
`
